import { FC, ReactNode, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "./contexts/AppContext";
import CustomLayout from "./components/Layout/CustomLayout";
import { Loading } from "./commons/components/Loading";
import LoginLayout from "./components/Layout/LoginLayout";
import { NOT_FOUND, routers, titles } from "./commons/constants/routers";
import LayoutMerchantMember from "./components/Layout/CustomLayout/LayoutMerchantMember";
import { MOBILE_BREAKPOINT } from "./commons/constants";
import { MODES } from "./commons/constants/user";

const AppContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const { user, setIsMobile } = useContext(AppContext);
  const { pathname } = useLocation();
  const publicRoutes = [
    routers.LOGIN,
    routers.RESET_PASSWORD,
    routers.SIGN_UP,
    routers.FORGOT_PASSWORD,
    routers.FORGOT_SUCCESS,
    routers.CALL,
    routers.WELCOME,
  ];

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsMobile(width < MOBILE_BREAKPOINT);
  }, [width]);

  useEffect(() => {
    document.title = Object.entries(titles).find(([key]) => pathname.includes(key))?.[1] || NOT_FOUND;
  }, [pathname]);

  switch (true) {
    case !user && !publicRoutes.includes(pathname) && !pathname.includes("/merchant-onboard/accept"):
      return <Navigate to={routers.LOGIN} state={{ from: pathname }} replace />;
    case user && !user.id:
      return <Loading />;
    case user && pathname === routers.LOGIN:
      return <Navigate to={routers.STORES.LIST} state={{ from: pathname }} replace />;
    case publicRoutes.includes(pathname) || pathname.includes("/merchant-onboard/accept"):
      return <LoginLayout>{children}</LoginLayout>;
    case user?.merchant_role?.id === MODES.ADMIN:
      return <CustomLayout>{children}</CustomLayout>;
    case user?.merchant_role?.id === MODES.USER:
      return <LayoutMerchantMember>{children}</LayoutMerchantMember>;
    case user?.merchant_role?.id === MODES.DRIVER:
      return <Navigate to={routers.WELCOME} replace />;
    default:
      return null;
  }
};

export default AppContainer;
